module.exports = __webpack_public_path__ + "static/img/marcadorNegro.22ff8f3a.png";